export enum INPUT_TYPE {
    NUMBER = 'number',
    DATE_RANGE = 'date',
    TIME_RANGE = 'time',
    TEXT = 'text'
}
